import CityPageTemplate from "@/components/site/CityPageTemplate";

export default function FinanzberatungWilhelmshaven() {
  return (
    <CityPageTemplate
      city="Wilhelmshaven"
      slug="wilhelmshaven"
      intro="Wilhelmshaven als einziger Tiefwasserhafen Deutschlands – wir bringen Deine Finanzen in ruhige Gewässer."
      description="Unabhängige & digitale Finanzberatung für Wilhelmshaven: Altersvorsorge, ETF, Steueroptimierung und staatliche Förderungen. Kostenlose Erstberatung – 100% digital."
    />
  );
}
